module.exports = __webpack_public_path__ + "static/media/soul-and-mindful.c3baad07.svg";